// extracted by mini-css-extract-plugin
export default {"container":"container-uq6ez","contactWrapper":"contactWrapper-Q9gYG","fullWidth":"fullWidth-dtgNh"};